import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';

/**
 * Toggle button group for filtering crops by type
 * Maps crop type values to display labels for the UI
 */
const CROP_TYPE_TOGGLE_OPTIONS = [
  { value: 'vegetable', label: 'Vegetables' },
  { value: 'cover_crop', label: 'Cover crops' },
  { value: 'herb', label: 'Herbs' },
  { value: 'fruit', label: 'Fruits' }
];

const CropTypeToggle = ({ selectedCropType, onCropTypeChange }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
      <ToggleButtonGroup
        value={selectedCropType}
        exclusive
        onChange={(event, newValue) => {
          if (newValue !== null) {
            onCropTypeChange(newValue);
          }
        }}
        aria-label="crop type filter"
        sx={{
          '& .MuiToggleButton-root': {
            fontFamily: 'var(--font-serif)',
            color: 'var(--color-ink)',
            borderColor: 'var(--color-border-vintage)',
            '&.Mui-selected': {
              backgroundColor: 'var(--color-accent-gold)',
              color: 'var(--color-ink)',
              '&:hover': {
                backgroundColor: 'var(--color-sepia)',
              }
            },
            '&:hover': {
              backgroundColor: 'rgba(184, 168, 138, 0.1)',
            }
          }
        }}
      >
        {CROP_TYPE_TOGGLE_OPTIONS.map((option) => (
          <ToggleButton
            key={option.value}
            value={option.value}
            aria-label={option.value}
          >
            {option.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
};

export default CropTypeToggle;



